import {DateTime, GuiUserlisting, HseGuideline, PhoneNumber, TerminalLocationShortInfo} from "@/modules/models";
import {maybeNum, maybeStr, numOrNull, requireNum, requireStr} from "@/modules/utils";

export class PersonConfirmedHseGuideline {
    public constructor(
        public personGuid: string,
        public personFirstName: string | null,
        public personLastName: string | null,
        public personBirthDate: DateTime | null,
        public confirmedTs: DateTime | null,
    ) {}

    static fromJson(json: any): PersonConfirmedHseGuideline {
        return new PersonConfirmedHseGuideline(
            requireStr(json.personGuid),
            maybeStr(json.personFirstName),
            maybeStr(json.personLastName),
            DateTime.maybeFromJson(json.personBirthDate),
            DateTime.maybeFromJson(json.confirmedTs),
        );
    }
}

export class PersonNotConfirmedHseGuideline {
    public constructor(
        public personGuid: string,
        public personFirstName: string | null,
        public personLastName: string | null,
        public personBirthDate: DateTime | null,
        public lastRegInTs: DateTime | null
    ) {}

    static fromJson(json: any): PersonNotConfirmedHseGuideline {
        return new PersonNotConfirmedHseGuideline(
            requireStr(json.personGuid),
            maybeStr(json.personFirstName),
            maybeStr(json.personLastName),
            DateTime.maybeFromJson(json.personBirthDate),
            DateTime.maybeFromJson(json.lastRegInTs),
        );
    }
}


export class PersonsHseGuidelineConfirmedReportResult {
    // notConfirmed holds persons that has registered into location guideline belongs to, but not confirmed the given guideline (+ version).
    public constructor(public guideline: HseGuideline, public confirmed: PersonConfirmedHseGuideline[], public notConfirmed: PersonNotConfirmedHseGuideline[]) {}

    static fromJson(json: any): PersonsHseGuidelineConfirmedReportResult {
        const guideline = HseGuideline.fromJson(json.guideline);
        const confirmed = (json.confirmed as any[]).map(r => PersonConfirmedHseGuideline.fromJson(r));
        const notConfirmed = (json.notConfirmed as any[]).map(r => PersonNotConfirmedHseGuideline.fromJson(r));
        return new PersonsHseGuidelineConfirmedReportResult(guideline, confirmed, notConfirmed);
    }
}

export class PersonRefAndDateInterval {
    public constructor(public personRef: string, public from: DateTime, public to: DateTime) {}
}

export class TerminalLocationInfoDateInterval {
    public constructor(public terminalLocationInfo: TerminalLocationShortInfo, public from: DateTime, public to: DateTime) {}

    static fromJson(json: any): TerminalLocationInfoDateInterval {
        const tl = TerminalLocationShortInfo.fromJson(json.terminalLocationInfo);
        return new TerminalLocationInfoDateInterval(tl, DateTime.fromJson(json.from), DateTime.fromJson(json.to));
    }
}

export class InfectionTraceRow {

    public constructor(
        public personGuid: string,
        public firstName: string | null,
        public lastName: string | null,
        public birthDate: DateTime | null,
        public companyOrgnum: number | null,
        public companyName: string | null,
        public phones: PhoneNumber[],
    ) {}

    static fromJson(json: any): InfectionTraceRow {
        return new InfectionTraceRow(
            requireStr(json.personGuid),
            maybeStr(json.firstName),
            maybeStr(json.lastName),
            DateTime.maybeFromJson(json.birthDate),
            maybeNum(json.companyOrgnum),
            maybeStr(json.companyName),
            (json.phones as any[]).map(r => PhoneNumber.fromJson(r))
        );
    }
}

export class GuiUserlistingAndDateInterval {
    public constructor(public person: GuiUserlisting, public from: DateTime, public to: DateTime) {}
}

export class InfectionTraceXlsxParams {
    public constructor(public personIntervals: GuiUserlistingAndDateInterval[], public locationIntervals: TerminalLocationInfoDateInterval[]) {}
}

export class PersonMissingPhoneReportRow {
    public constructor(
        public guid: string,
        public firstName: string | null,
        public lastName: string | null,
        public birthDate: DateTime | null,
        public companyOrgnum: number | null,
        public companyName: string | null,
        public cardNum: number | null,
        public lastTimeIn: DateTime,
        public lastLocId: number,
        public lastLocDescr: string,
    ) {}

    static fromJson(json: any): PersonMissingPhoneReportRow {
        return new PersonMissingPhoneReportRow(
            requireStr(json.guid),
            maybeStr(json.firstName),
            maybeStr(json.lastName),
            DateTime.maybeFromJson(json.birthDate),
            numOrNull(json.companyOrgnum),
            maybeStr(json.companyName),
            numOrNull(json.cardNum),
            DateTime.fromJson(json.lastTimeIn),
            requireNum(json.lastLocId),
            requireStr(json.lastLocDescr),
        )
    }
}